<ng-container *transloco="let _t">

<div class="row building">
	<div class="col-4">
		<cmat-picture [src]="model.photo" alt="Image"
		[zoomed]="true" [uploadable]="false" [resizeOnClick]="false"></cmat-picture>
	</div>

	<div class="col-8">
		<h2>
			{{model.name}}
			<small>( {{model.BuildingType.name}} )</small>
		</h2>
		<div class="row">
		  <address class="col-4">
			<h3>{{ _t('building-listitem-h3-0') }} </h3>
			<p>{{model.adress1}}<br/>
				<span *ngIf="model.adress2!=undefined">
					{{model.adress2}}<br/></span>
				{{model.zipcode}} {{model.town}}</p>
		  </address>

      <address class="col-4">
			<h3>{{ _t('building-listitem-h3-1') }}</h3>
			<p>{{model.User.name}} <br>
			 <a [href]="'mailto:'+model.User.email">{{model.User.email}}</a>
			 <br>
			 {{model.User.phone}}</p>
      </address>

      <address class="col-4" *ngIf="model.director!=undefinded">
				<h5>{{ _t('main-header-h5-1') }}</h5>
				<p>{{model.director}} <br>
				<a [href]="'mailto:'+model.email">{{model.email}}</a><br>
				{{model.phone}}</p>
			</address>
		</div>


		<button mat-raised-button
			class="col-3" color="basic"
			[routerLink]="[model.id]">
			<mat-icon class="md-12">location_city</mat-icon>
			{{ _t('building-listitem-button') }}
		</button>

	</div>
</div>

</ng-container>
